import styled from 'styled-components';

export const ConteinerSeletor = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  width: 100%;
`;

export const BordaSeletor = styled.span`
  position: absolute;
  top: 50px;

  width: ${(props) => (props.$erro ? '100%' : 0)};
  height: 2px;

  background-color: ${(props) => (props.$erro ? props.theme.DANGER : props.theme.PRIMARY)};

  transition: 0.4s;
`;

export const InputField = styled.select`
  width: 100%;
  padding: 7px 0 2px 5px;

  color: ${(props) => props.theme.DARK};
  background-color: ${(props) => props.theme.MEDIUM};
  background-size: contain;
  border: 0;
  border-bottom: 1px solid #ccc;
  border-radius: 5px 5px 0px 0px;
  box-sizing: border-box;

  font:
    15px/24px 'Lato',
    arial,
    sans-serif;
  letter-spacing: 1px;

  appearance: none;

  &:focus {
    outline: none;
    outline-offset: 0;
  }

  &:focus ~ ${BordaSeletor} {
    width: 100%;
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
`;

export const TextoDeErro = styled.span`
  color: ${(props) => props.theme.DANGER};
`;
